'use strict';
function removeAccents (str) {
    let normalizedString = str.normalize("NFD")
    let removedAccents = normalizedString.replace(/[\u0300-\u036f]/g, "")
    return removedAccents.replace(/\s/g, "-").replace(/\//g, "");
}

function setMaxValue() {
    var priceRanges = $('[data-prices]');
    var priceInputMin = $('[data-min-input-price]');
    var priceSlideMin = $('[data-range-min-price]');
    var priceInputMax = $('[data-max-input-price]');
    var priceSlideMax = $('[data-range-max-price]');

    var maxPrice = parseInt(priceRanges.text().split('-')[1]);

    priceInputMin.attr('max', maxPrice);
    priceInputMin.attr('value', 0);
    priceSlideMin.attr('max', maxPrice);
    priceSlideMin.attr('min', 0);
    priceInputMax.attr('max', maxPrice);
    priceInputMax.attr('value', maxPrice);
    priceSlideMax.attr('max', maxPrice);
    priceSlideMax.attr('value', maxPrice);

    priceSlideFuntacionality();

    var currentUrl = localStorage.getItem('currentUrl');
    if(currentUrl.includes('?cgid=')) {
        currentUrl = currentUrl.split('?cgid=')[1];
    }
    var windowUrl = window.location.pathname.substring(18);
    windowUrl = decodeURIComponent(windowUrl);
    windowUrl = removeAccents(windowUrl);
    if(windowUrl.includes('de-')) {
        windowUrl = windowUrl.replace('de-','');
    }
    if(currentUrl==windowUrl) {
        var selectedFilter = priceRanges.siblings('.fa');
        selectedFilter.removeClass('fa-check-square').addClass('fa-square-o');
        selectedFilter.parents('.card-body').siblings('.card-header').removeClass('active-filter');
        $('[data-reset-button]').addClass('d-none')
    }
}

function displayActualPriceFilter(min, max, isReset) {
    var priceRanges = $('[data-prices]');
    var selectedFilter = priceRanges.siblings('.fa');
    var selectedMinPrice = parseInt(min);
    var SelectedMaxPrice = parseInt(max);

    var priceInputMin = $('[data-min-input-price]');
    var priceSlideMin = $('[data-range-min-price]');
    var priceInputMax = $('[data-max-input-price]');
    var priceSlideMax = $('[data-range-max-price]');

    var maxPrice = parseInt(priceRanges.text().split('-')[1]);

    priceInputMin.attr('min', 0);
    priceInputMin.attr('max', maxPrice);
    priceInputMin.attr('value', selectedMinPrice);

    priceSlideMin.attr('min', 0);
    priceSlideMin.attr('max', maxPrice);
    priceSlideMin.attr('value', selectedMinPrice);

    priceInputMax.attr('min', 0);
    priceInputMax.attr('max', maxPrice);
    priceInputMax.attr('value', SelectedMaxPrice);

    priceSlideMax.attr('min', 0);
    priceSlideMax.attr('max', maxPrice);
    priceSlideMax.attr('value', SelectedMaxPrice);

    priceSlideFuntacionality();

    if (SelectedMaxPrice != maxPrice || selectedMinPrice != 0) {
        selectedFilter.removeClass('fa-square-o').addClass('fa-check-square');
    } else if (selectedFilter.hasClass('fa-check-square')) {
        selectedFilter.removeClass('fa-check-square').addClass('fa-square-o');
    }

    if (isReset.includes('reset')) {
        selectedFilter.removeClass('fa-check-square').addClass('fa-square-o');
    }
}

function setSliderColor(progress, range, minRange, maxRange, inputValue) {
    progress.style.left = (minRange / range[0].max) * 100 + "%";
    progress.style.right = 100 - (maxRange / range[1].max) * 100 + "%";
    inputValue[0].value = minRange;
    inputValue[1].value = maxRange;
}

function priceSlideFuntacionality() {
    const range = document.querySelectorAll(".range-slider span input");
    const progress = document.querySelector(".range-slider .progress");
    const inputValue = document.querySelectorAll(".numberVal input");

    if (range.length > 0) {
        let gap = 0.1;
        let minRange = parseInt(range[0].value);
        let maxRange = parseInt(range[1].value);

        setSliderColor(progress, range, minRange, maxRange, inputValue);
        setPriceSearchUrl();

        range.forEach((input) => {
            input.addEventListener("input", (e) => {
                minRange = parseInt(range[0].value);
                maxRange = parseInt(range[1].value);

                if (maxRange - minRange < gap) {
                    if (e.target.className === "range-min") {
                        range[0].value = maxRange - gap;
                    } else {
                        range[1].value = minRange + gap;
                    }
                } else {
                    setSliderColor(progress, range, minRange, maxRange, inputValue);
                    setPriceSearchUrl();
                }
            });
        });
    }
};

function setPriceSearchUrl() {
    var buttonSearchPrices = $('[data-search-prices]');
    var priceInputMin = parseInt($('[data-min-input-price]').val());
    var priceInputMax = parseInt($('[data-max-input-price]').val()) + 1;

    var minPrice = Number(priceInputMin).toLocaleString().replace(',', '%2e');
    var maxPrice = Number(priceInputMax).toLocaleString().replace(',', '%2e');

    var priceUrl = $('[data-url-prices]').text().split('pmin')[0] + 'pmin=' + minPrice + '&pmax=' + maxPrice;

    buttonSearchPrices.attr('data-href', priceUrl);
    buttonSearchPrices.attr('data-min-price', priceInputMin);
    buttonSearchPrices.attr('data-max-price', priceInputMax);
}

module.exports = {
    displayActualPriceFilter: displayActualPriceFilter,
    setMaxValue: setMaxValue
}
